/**
 * Web component: Doogma charms button (doogma-charms-button)
 * -----------------------------------------------------------------------------
 * Updates state of button based on event emit from doogma-charms component.
 *
 */

/**
 * Create new <doogma-charms-button> custom element.
 */
class DoogmaCharmsButton extends HTMLElement {

  /**
   * Custom element constructor.
   * - Always call super first in constructor.
   */
  constructor() {
    super()
    this.buttonIcon = this.querySelector('[js-doogma-charms="button-icon"]')
    this.buttonText = this.querySelector('[js-doogma-charms="button-text"]')
    this.trigger = this.querySelector('[js-doogma-charms="trigger"]')
  }

  /**
   * Lifecycle hook - component is attached to the DOM.
   * - Look at sessionStorage in case charms loaded before button was ready.
   * - Button click event is handled by Doogma.
   */
  async connectedCallback() {
    if (sessionStorage.getItem('doogma-ready')) {
      this.setReadyState()
    }

     document.addEventListener('doogmaButtonLoading', this.setLoadingState.bind(this))
     document.addEventListener('doogmaButtonReady', this.setReadyState.bind(this))
  }

  /**
   * Set button loading state.
   */
  setLoadingState() {
    this.trigger.setAttribute('disabled', true)
    if (this.buttonIcon) this.buttonIcon.innerHTML = window.icons.doogma.loading
    if (this.buttonText) this.buttonText.innerText = this.dataset.labelLoading
  }

  /**
   * Set button ready state.
   */
  setReadyState() {
    this.trigger.removeAttribute('disabled')
    if (this.buttonIcon) this.buttonIcon.innerHTML = window.icons.doogma.diamond
    if (this.buttonText) this.buttonText.innerText = this.dataset.labelReady
  }
}

customElements.define('doogma-charms-button', DoogmaCharmsButton)
